module.exports = __webpack_public_path__ + "static/img/yongyaozhidao@3x.0c6caad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bingchengguanli/yongyaozhidao@3x.png
// module id = /CSQ
// module chunks = 1